var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "#2B3238",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3238",
    fillRule: "nonzero",
    d: "M9.089 4.441c.256-.235.385-.521.385-.857 0-.335-.129-.62-.385-.858a1.313 1.313 0 0 0-.926-.358c-.36 0-.67.12-.928.358a1.13 1.13 0 0 0-.386.858c0 .336.13.622.386.857.258.236.569.354.928.354.361 0 .67-.118.926-.354zm-.591 7.876c.463-.214.707-.615.467-.8-.138-.105-.32.07-.452.07-.285 0-.485-.046-.6-.138-.117-.094-.173-.267-.173-.522 0-.102.016-.251.052-.45.035-.198.077-.375.12-.53l.55-1.922c.052-.176.09-.37.111-.581.02-.213.03-.36.03-.444 0-.404-.145-.734-.432-.988-.286-.253-.696-.38-1.227-.38-.295 0-.608.042-.937.155-.644.223-.501.777-.358.777.29 0 .485.049.588.146.103.096.156.268.156.515 0 .136-.02.288-.052.453-.034.165-.073.34-.123.525l-.553 1.93a6.749 6.749 0 0 0-.106.545 3.48 3.48 0 0 0-.033.474c0 .396.148.722.444.98a1.99 1.99 0 0 0 1.285.5c.347 0 .842-.128 1.243-.315z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.73e229273d15bc36de0e69a20dc61ec5.svg";
export { ForwardRef as ReactComponent };